/**
 * Utility to map products to high-res product photography,
 * avoiding SVG placeholders when displaying products across cards, galleries, and cart.
 */

export function getDefaultImageForProduct(slugOrName?: string, index: number = 0): string {
  const lower = (slugOrName || '').toLowerCase();

  if (lower.includes('single') || lower.includes('one')) {
    return index === 0 ? '/images/product-toothbrush-single.png' : '/images/ritual-toothbrushes-cup.png';
  }

  if (lower.includes('travel') || lower.includes('tube') || lower.includes('refill')) {
    return index === 0 ? '/images/product-travel-tubes.png' : '/images/hero-bamboo-oral-care.png';
  }

  // Set / Bundle / Default
  if (index === 0) return '/images/product-set-packaging.png';
  if (index === 1) return '/images/product-set-inside.png';
  return '/images/hero-bamboo-oral-care.png';
}

export function sanitizeImageUrl(url?: string, slugOrName?: string, index: number = 0): string {
  if (!url || url.includes('botanical-placeholder.svg') || url.trim() === '') {
    return getDefaultImageForProduct(slugOrName, index);
  }
  return url;
}
